// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body {
  margin: 0;
  padding: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  background-color: #121212;
  color: #ffffff;
}

/* Remove default blue background from browser autofill and match dark theme */
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  box-shadow: 0 0 0 1000px #121212 inset;
  -webkit-text-fill-color: #ffffff;
  caret-color: #ffffff;
}

/* Respect safe areas (notch / home indicator) on mobile */
#root {
  padding-bottom: env(safe-area-inset-bottom, 0px);
}

/* Simple flash animation for camera capture */
@keyframes camera-flash {
  from {
    opacity: 0.8;
  }
  to {
    opacity: 0;
  }
}

/* Provide space for bottom tab bar on smaller screens */
@media (max-width: 900px) {
  :root {
    --bottom-nav-height: 72px;
  }
  body {
    padding-bottom: calc(var(--bottom-nav-height) + env(safe-area-inset-bottom, 0px));
  }
}
`, "",{"version":3,"sources":["webpack://./src/global.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,8EAA8E;AAC9E;;;;;;;;;EAUE,sCAAsC;EACtC,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA,0DAA0D;AAC1D;EACE,gDAAgD;AAClD;;AAEA,8CAA8C;AAC9C;EACE;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;AACF;;AAEA,wDAAwD;AACxD;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,iFAAiF;EACnF;AACF","sourcesContent":["html, body {\n  margin: 0;\n  padding: 0;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\nbody {\n  background-color: #121212;\n  color: #ffffff;\n}\n\n/* Remove default blue background from browser autofill and match dark theme */\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ntextarea:-webkit-autofill,\ntextarea:-webkit-autofill:hover,\ntextarea:-webkit-autofill:focus,\nselect:-webkit-autofill,\nselect:-webkit-autofill:hover,\nselect:-webkit-autofill:focus {\n  -webkit-box-shadow: 0 0 0 1000px #121212 inset;\n  box-shadow: 0 0 0 1000px #121212 inset;\n  -webkit-text-fill-color: #ffffff;\n  caret-color: #ffffff;\n}\n\n/* Respect safe areas (notch / home indicator) on mobile */\n#root {\n  padding-bottom: env(safe-area-inset-bottom, 0px);\n}\n\n/* Simple flash animation for camera capture */\n@keyframes camera-flash {\n  from {\n    opacity: 0.8;\n  }\n  to {\n    opacity: 0;\n  }\n}\n\n/* Provide space for bottom tab bar on smaller screens */\n@media (max-width: 900px) {\n  :root {\n    --bottom-nav-height: 72px;\n  }\n  body {\n    padding-bottom: calc(var(--bottom-nav-height) + env(safe-area-inset-bottom, 0px));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
